import { render, staticRenderFns } from "./limitedTimeOfferList.vue?vue&type=template&id=1927fc76"
import script from "./limitedTimeOfferList.vue?vue&type=script&lang=js"
export * from "./limitedTimeOfferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports